/**
 * Hero của trang quán: tên, slogan, giới thiệu ngắn, địa chỉ, giờ mở cửa, số bàn.
 *
 * Trang này không còn luồng đặt bàn — hành động duy nhất là gọi hotline, nên
 * nút gọi là nút chính ở đây (và lặp lại ở thanh dính đáy màn hình). "Chỉ
 * đường" đứng cạnh làm nút phụ.
 *
 * Mọi phần đều có thể rỗng vì admin không bắt buộc nhập — thiếu phần nào thì
 * ẩn đúng phần đó. Riêng ảnh bìa thiếu thì đổi sang nền màu thương hiệu chứ
 * không để khung ảnh vỡ.
 */
import React from "react";
import TIcon from "../../components/ui/TIcon";
import { Venue } from "../../interfaces/venue";
import { composeAddress, directionsUrl, telHref } from "../../helpers/venue";

interface Props {
  venue: Venue;
}

const HeroSection: React.FC<Props> = ({ venue }) => (
  <header className={`vn-hero bleed${venue.coverImage ? "" : " no-cover"}`}>
    {venue.coverImage ? (
      <img className="vn-hero-bg" src={venue.coverImage} alt="" aria-hidden />
    ) : null}
    <div className="vn-hero-veil" />

    <div className="vn-hero-inner">
      {venue.logo ? (
        <img
          className="vn-hero-logo"
          src={venue.logo}
          alt={`Logo ${venue.name}`}
        />
      ) : null}

      <h1>{venue.name}</h1>
      {venue.headline ? (
        <div className="vn-hero-headline">{venue.headline}</div>
      ) : null}
      {venue.intro ? <p className="vn-hero-intro">{venue.intro}</p> : null}

      <div className="vn-hero-facts">
        <div className="vn-fact">
          <TIcon name="map-pin" />
          <span>{composeAddress(venue.address)}</span>
        </div>
        {/* Giờ mở cửa không bắt buộc ở backoffice. Để trống thì ẩn cả dòng, chứ
            không bày ra một cái icon đồng hồ đứng một mình không chữ. */}
        {venue.openingHours && venue.openingHours.trim() ? (
          <div className="vn-fact">
            <TIcon name="clock-hour-4" />
            <span>{venue.openingHours}</span>
          </div>
        ) : null}
        <div className="vn-fact">
          <TIcon name="circles" />
          <span>{venue.tableCount} bàn</span>
        </div>
      </div>

      <div className="vn-hero-actions">
        <a className="vn-btn vn-btn-primary" href={telHref(venue.hotline)}>
          <TIcon name="phone" />
          Gọi {venue.hotline}
        </a>
        <a
          className="vn-btn vn-btn-ghost"
          href={directionsUrl(venue.address, venue.coordinates)}
          target="_blank"
          rel="noreferrer"
        >
          <TIcon name="navigation" />
          Chỉ đường
        </a>
      </div>
    </div>
  </header>
);

export default HeroSection;
